import React from "react";

const ToggleSwitch = ({ value, onChange, label }) => {
  return (
    <>
      {label && <span className="automation-label">{label}</span>}
      <div className="toggle-switch">
        <div
          className={`toggle-option ${value ? "selected" : ""}`}
          onClick={() => onChange(true)}
        >
          <span>Yes</span>
        </div>
        <div
          className={`toggle-option ${!value ? "selected" : ""}`}
          onClick={() => onChange(false)}
        >
          <span>No</span>
        </div>
      </div>
    </>
  );
};

export default ToggleSwitch;
